// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class AuthorisedPersonResource extends Resource {
    basePath: string = 'sites/sites/{parent}/authorised-people/';

    objectPath: string = 'sites/sites/{parent}/authorised-people/{ident}/';
}
